import {
    faCalendarLines,
    faClock,
    faCoins,
    faFire,
    faMemoPad,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IssueMetricType } from 'shared/issue_metrics/types';
import { Lookup } from 'utils/types';

export const METRIC_ICONS: Lookup<IssueMetricType, JSX.Element> = {
    new: <FontAwesomeIcon icon={faMemoPad} size="sm" />,
    open: <FontAwesomeIcon icon={faMemoPad} size="sm" />,
    severe: <FontAwesomeIcon icon={faFire} size="sm" />,
    days: <FontAwesomeIcon icon={faCalendarLines} size="sm" />,
    downtime: <FontAwesomeIcon icon={faClock} size="sm" />,
    savings: <FontAwesomeIcon icon={faCoins} size="sm" />,
};

export function MetricIcon({ type }: { type: IssueMetricType }) {
    return METRIC_ICONS[type];
}
